import { RestClient, RequestResponse } from "@infrastructure/clients/http/clients/base/rest.client";
import { CommonDto } from "@infrastructure/clients/http/common.dto";
import { BASE_URL } from "@infrastructure/clients/http/config";
import {
  CardListResponseSchema,
  CardResponseSchema,
  CardInfoSchema,
} from "@infrastructure/clients/http/clients/creditCard.schemas";
import * as z from "zod";

class CreditCardClientClass extends RestClient {
  baseUrl = BASE_URL;

  async getCards(): Promise<RequestResponse<z.infer<typeof CardListResponseSchema>>> {
    const result = await this.request("GET", "/api/cards");
    
    // Если сервер вернул массив вместо объекта с полем cards - оборачиваем его
    if (Array.isArray(result.data)) {
      result.data = { cards: result.data };
    }
    
    return this.validateResponse(result, CommonDto.withStatus(CardListResponseSchema));
  }

  async addCard(phone?: string): Promise<RequestResponse<z.infer<typeof CardResponseSchema>>> {
    const result = await this.request(
      "POST",
      "/api/cards",
      {
        jsonPayload: phone ? { Phone: phone } : {},
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(CardResponseSchema));
  }

  async setCardDefault(card_id: number): Promise<RequestResponse<z.infer<typeof CardInfoSchema>>> {
    const result = await this.request(
      "PATCH",
      `/api/cards/${card_id}`,
      {}
    );
    return this.validateResponse(result, CommonDto.withStatus(CardInfoSchema));
  }

  async deleteCard(card_id: number): Promise<RequestResponse<z.infer<typeof CardResponseSchema>>> {
    const result = await this.request(
      "DELETE",
      "/api/cards",
      {
        params: { card_id },
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(CardResponseSchema));
  }
}

export class CreditCardClient extends CreditCardClientClass {}
